import { render } from "./MechanicNotes.vue?vue&type=template&id=45978910&scoped=true"
import script from "./MechanicNotes.vue?vue&type=script&lang=js"
export * from "./MechanicNotes.vue?vue&type=script&lang=js"

import "./MechanicNotes.vue?vue&type=style&index=0&id=45978910&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45978910"]])

export default __exports__